var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":true,"show-close":false,"top":_vm.windowTop}},[(_vm.componentName === 'slot')?_vm._t("default"):_vm._e(),_vm._v(" "),_c(_vm.componentName,{tag:"component",attrs:{"solutionId":_vm.detailId,"contentTitle":_vm.solutionTitle},on:{"close":function($event){return _vm.$emit('close')}}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25ee7bf1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-mask.vue
// module id = null
// module chunks = 